<template>
    <div>
        <div class="relative text-gray-500 focus-within:text-primary-500">
            <input
                ref="cep"
                class="input pl-7"
                :class="{ rounded: !showAllFields, 'rounded-b-none rounded-t-lg': showAllFields }"
                v-model="model.br_address_cep"
                @blur="searchCep()"
                :placeholder="__('Digite o CEP (ex: 12400-040)')"
            />

            <div class="absolute inset-y-0 left-0 mx-2 flex items-center">
                <svg v-show="!loading" class="h-4 w-4" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        fill-rule="evenodd"
                        d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                        clip-rule="evenodd"
                    />
                </svg>

                <svg v-show="loading" class="h-4 w-4 animate-spin" viewBox="0 0 20 20" fill="currentColor">
                    <path
                        fill-rule="evenodd"
                        d="M4 2a1 1 0 011 1v2.101a7.002 7.002 0 0111.601 2.566 1 1 0 11-1.885.666A5.002 5.002 0 005.999 7H9a1 1 0 010 2H4a1 1 0 01-1-1V3a1 1 0 011-1zm.008 9.057a1 1 0 011.276.61A5.002 5.002 0 0014.001 13H11a1 1 0 110-2h5a1 1 0 011 1v5a1 1 0 11-2 0v-2.101a7.002 7.002 0 01-11.601-2.566 1 1 0 01.61-1.276z"
                        clip-rule="evenodd"
                    />
                </svg>
            </div>
        </div>

        <button
            v-show="!hasValidCep && !showAllFields"
            class="-mt-2 text-xs text-secondary"
            @click="showAllFields = true"
        >
            {{ __('Não lembro o CEP') }}
        </button>

        <div v-show="showAllFields" class="bg-gray-50 p-2 border-b border-l border-r border-gray-300 rounded-b-lg">
            <div class="flex gap-2">
                <div class="w-1/3">
                    <label class="label">{{ __('Cidade') }}</label>
                    <input class="input" v-model="model.br_address_cidade" />
                </div>
                <div class="w-1/3">
                    <label class="label">{{ __('Estado') }}</label>
                    <input class="input" v-model="model.br_address_estado" />
                </div>
                <div class="w-1/3">
                    <label class="label">{{ __('Bairro') }}</label>
                    <input class="input" v-model="model.br_address_bairro" />
                </div>
            </div>

            <div class="flex gap-2">
                <div class="w-1/2">
                    <label class="label">{{ __('Logradouro') }}</label>
                    <input class="input" v-model="model.br_address_logradouro" />
                </div>
                <div class="flex w-1/2 gap-2">
                    <div class="w-1/2">
                        <label class="label">{{ __('Nº') }}</label>
                        <input class="input" v-model="model.br_address_numero" />
                    </div>
                    <div class="w-1/2">
                        <label class="label">{{ __('Compl.') }}</label>
                        <input class="input" v-model="model.br_address_complemento" :placeholder="__('Ex: Apto 107')" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import * as Form from '@App/Utils/Form'
import axios from 'axios'

export default {
    props: ['value', 'field', 'values'],
    mounted() {
        this.$el.validateRequired = () => {
            return (
                this.model.br_address_cep &&
                this.model.br_address_cep.length > 5 &&
                this.model.br_address_numero &&
                this.model.br_address_numero.length > 0
            )
        }
    },
    data() {
        return {
            showAllFields: this.values.br_address_pais,
            loading: false,
            model: {
                br_address_cep: this.values.br_address_cep,
                br_address_pais: this.values.br_address_pais,
                br_address_estado: this.values.br_address_estado,
                br_address_cidade: this.values.br_address_cidade,
                br_address_bairro: this.values.br_address_bairro,
                br_address_logradouro: this.values.br_address_logradouro,
                br_address_numero: this.values.br_address_numero,
                br_address_complemento: this.values.br_address_complemento,
            },
        }
    },
    watch: {
        model: {
            handler: function () {
                this.$emit('input', { ...this.model, _spread: true })
            },
            deep: true,
        },

        'model.br_address_cep': function (value) {
            if (value.length == '12400040'.length) {
                this.$refs.cep.blur()
                this.searchCep()
            }
        },

        'model.br_address_logradouro': function (value) {
            this.model[Form.name(this.field)] = value
        },
    },
    computed: {
        hasValidCep() {
            if (!this.model.br_address_cep) return false
            return this.model.br_address_cep.length >= '12400040'.length
        },

        placeholder() {
            return Form.placeholder(this.field)
        },
    },
    methods: {
        async searchCep() {
            this.loading = true
            let value = this.model.br_address_cep

            if (value && value.length >= '12400040'.length) {
                let cep = value.replace(/[^0-9]/, '')
                let url = 'https://viacep.com.br/ws/' + cep + '/json/'
                let { data } = await axios.get('/api/proxy', { params: { url, method: 'get' } })

                this.model.br_address_logradouro = data.logradouro
                this.model[Form.name(this.field)] = data.logradouro
                this.model.br_address_bairro = data.bairro
                this.model.br_address_cidade = data.localidade
                this.model.br_address_estado = data.uf
                this.model.br_address_pais = 'Brasil'
                this.showAllFields = true
            }

            this.loading = false
        },
    },
}
</script>
